import React from 'react'
import TableFilterCheckbox from '@/components/detail/DetailTable/TableToolbar/TableFilters/TableFilterCheckbox'

type Props = {
    checked: boolean
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export default function Exome({ checked, onChange }: Props) {
    return (
        <TableFilterCheckbox
            title='Exome'
            checked={checked}
            onChange={onChange}
        />
    )
}
